import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionAtencionListaComponent {
  clienteId
  data = []

  constructor (ClienteInformacionAtencionClientes) {
    this.ClienteInformacionAtencionClientesService = ClienteInformacionAtencionClientes
  }

  $onInit () {
    this.promise = this.ClienteInformacionAtencionClientesService.get(this.clienteId)
      .then(({data}) => (this.data = data))
  }

  eliminar (item) {
    this.data = this.data.filter((items) => items.atencion_id !== item.atencion_id)
  }
}

module.component('clienteInformacionAtencionLista', {
  controller: ClienteInformacionAtencionListaComponent,
  template,
  bindings: {
    clienteId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/atencion/lista/component.js